import type { SvdNativeCardVariant, SvdNativeProduct } from '@src/types/svd-product-card.types'

/**
 * Picks the initial selected variant for an SVD card. Variant-id keyed (not color) — falls back to
 * the first variant. Mirrors the legacy `getInitialSelectedVariant` but on the native SVD type.
 */
export function getInitialSvdVariant(
  cardVariants: SvdNativeCardVariant[],
  selectedVariantId?: number,
): SvdNativeCardVariant | undefined {
  if (!selectedVariantId) return cardVariants[0]
  return cardVariants.find(variant => variant.variantId === selectedVariantId) ?? cardVariants[0]
}

/**
 * Whether the card should render a swatch row: only when the product exposes a real anchor
 * dimension (`displayConfig` non-null) on more than one variant. No-VDA products (null config,
 * single variant) render without swatches.
 */
export function shouldRenderSvdSwatches(product: SvdNativeProduct): boolean {
  const swatchable = product.cardVariants.filter(variant => variant.displayConfig !== null)
  return swatchable.length > 1
}
